export default __webpack_public_path__ + "static/plainwax-7a49dfce981d4dcfa576a2ace7285067.webp";